function activeNpcs(caseConf) {
  if (!caseConf || !caseConf.npcs) return [];
  const npcs = [];
  const starting = caseConf.npcs.find(npc => npc.activeScenes.includes('_startLocation'));
  if (starting) {
    npcs.push(starting);
  }
  const ending = caseConf.npcs.find(npc => npc.activeScenes.includes('_endLocation') && !npc.activeScenes.includes('_startLocation'));
  if (ending && caseConf._endLocation) {
    npcs.push(ending);
  }
  return npcs;
}

function getNpcDialogue(caseConf) {
  const npcDialogue = {};
  const npcs = activeNpcs(caseConf) || [];
  if (npcs.length === 0) {
    return {};
  }
  npcs.forEach(npc => {
    if (!npc.dialogue) return;
    const npcDialogueKeys = Object.keys(npc.dialogue).filter(key => key !== '__typename');
    npcDialogueKeys.forEach(key => {
      if (!npcDialogue[key]) npcDialogue[key] = [];
      let dialogueEntries = npc.dialogue[key];
      if (typeof dialogueEntries === 'string') {
        dialogueEntries = [dialogueEntries];
      }
      if (!dialogueEntries || dialogueEntries.length === 0) return;
      npcDialogue[key] = npcDialogue[key].concat(dialogueEntries);
    });
  });
  return npcDialogue;
}

function isNpc(characterKey) {
  if (!characterKey) return false;
  return ['_startLocation', '_endLocation'].includes(characterKey);
}

function npcForScene(npcs, sceneKey) {
  return (npcs || []).find(npc => npc.activeScenes.includes(sceneKey));
}

const NpcType = Object.freeze({
  STARTING: 0,
  ENDING: 1,
  STARTING_AND_ENDING: 2,
  UNKNOWN: 3,
});

function getNpcType(npc) {
  const activeScenes = npc ? npc.activeScenes || [] : [];
  if (activeScenes.includes('_startLocation') && activeScenes.includes('_endLocation')) {
    return NpcType.STARTING_AND_ENDING;
  }
  else if (activeScenes.includes('_startLocation')) {
    return NpcType.STARTING;
  }
  else if (activeScenes.includes('_endLocation')) {
    return NpcType.ENDING;
  } else {
    return NpcType.UNKNOWN;
  }
}

function createDefaultDialogue(npc) {
  let npcDescription;
  switch(getNpcType(npc)) {
    case NpcType.STARTING_AND_ENDING:
      npcDescription = 'starting/ending VIP';
      break;
    case NpcType.STARTING:
      npcDescription = 'starting VIP';
      break;
    case NpcType.ENDING:
      npcDescription = 'ending VIP';
      break;
    case NpcType.UNKNOWN:
    default:
      npcDescription = 'VIP';
      break;
  }
  const defaultPrompt = `Write or paste your ${npcDescription} prompt here`;
  return {
    prompt: {
      markup: { en: defaultPrompt },
      content: { en: defaultPrompt }
    }
  };
}

function createDefaultRole(npc) {
  switch(getNpcType(npc)) {
    case NpcType.STARTING_AND_ENDING:
      return 'STARTING_ENDING_VIP';
    case NpcType.STARTING:
      return 'STARTING_VIP';
    case NpcType.ENDING:
      return 'ENDING_VIP';
    case NpcType.UNKNOWN:
    default:
      return 'VIP';
  }
}

module.exports = {
  activeNpcs,
  getNpcDialogue,
  isNpc,
  npcForScene,
  NpcType,
  getNpcType,
  createDefaultDialogue,
  createDefaultRole,
};

